import { Facebook, Youtube } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-scroll";
import { Logo } from "../../components/ui/logo";

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleLinkClick = (link) => {
    if (window.isLocalhost)
      navigate("/wordpress/new-home/", { state: { scrollTo: link.href } });
    else navigate("/", { state: { scrollTo: link.href } });
  };
  const links = [
    {
      name: "Features",
      href: "features",
    },
    {
      name: "Tools",
      href: "tools",
    },
    // {
    //   name: "FAQ",
    //   href: "faq",
    // },
    {
      name: "Pricing",
      href: "pricing",
    },
  ];
  const links2 = [
    {
      name: "Affiliates Program",
      href: "/wordpress/affiliates",
    },
  ];

  const legal = [
    {
      name: "Privacy Policy",
      href: "https://whizmanage.com/wp-content/uploads/2024/07/Terms-Conditions.pdf",
    },
    {
      name: "Terms & Conditions",
      href: "https://whizmanage.com/wp-content/uploads/2024/07/Terms-Conditions.pdf",
    },
    // {
    //   name: "Refund Policy",
    //   href: "#",
    // },
  ];
  const socials = [
    {
      name: "YouTube",
      href: "https://www.youtube.com/@Whizmanage",
      icon: <Youtube className="size-4" />,
    },
    {
      name: "Facebook",
      href: "https://www.facebook.com/profile.php?id=61559623972028&locale=he_IL",
      icon: <Facebook className="size-4" />,
    },
    {
      name: "Whatsapp",
      href: "https://wa.me/972533384771",
      icon: <FaWhatsapp className="size-4" />,
    },
    // {
    //   name: "GitHub",
    //   href: "https://github.com/manuarora700",
    // },
  ];
  return (
    <div className="relative dark bg-white dark:bg-black">
      <div className="p-4 md:px-10 border-t border-neutral-800/50 shadow-lg relative">
        <div className="max-w-7xl mx-auto text-sm text-neutral-500 dark:text-neutral-400 flex sm:flex-row flex-col sm:justify-between items-start ">
          <div className="flex flex-wrap md:flex-col justify-between items-center max-md:w-full">
            <div className="md:mr-4 md:flex md:mb-4">
              <Logo />
            </div>
            <div className="sm:pl-4 max-md:flex gap-2 mt-1">
              <div>
                <span className="max-sm:hidden">Whizmanage</span>
                &copy; 2024
              </div>
              <div className="md:mt-2">All rights reserved</div>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-10 items-start max-md:w-full mt-4">
            <div className="flex space-y-4 flex-col">
              {links.map((link) => (
                <div key={link.name}>
                  {(window.isLocalhost &&
                    location.pathname === "/wordpress/new-home/") ||
                  location.pathname === "/new-home/" ||
                  location.pathname === "/" ? (
                    <Link
                      to={link.href}
                      smooth={true}
                      duration={500}
                      offset={20}
                    >
                      <div className="transition-colors hover:text-black text-muted dark:text-muted-dark dark:hover:text-neutral-400 text-xs sm:text-sm cursor-pointer">
                        {link.name}
                      </div>
                    </Link>
                  ) : (
                    <div onClick={() => handleLinkClick(link)}>
                      <div className="transition-colors hover:text-black text-muted dark:text-muted-dark dark:hover:text-neutral-400 text-xs sm:text-sm cursor-pointer">
                        {link.name}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="flex justify-center space-y-4 flex-col">
              {socials.map((link) => (
                <a
                  key={link.name}
                  className="transition-colors hover:text-black text-muted dark:text-muted-dark dark:hover:text-neutral-400 text-xs sm:text-sm flex gap-1 items-center"
                  href={link.href}
                  target="_blank"
                >
                  {link.icon}
                  {link.name}
                </a>
              ))}
            </div>
            <div className="flex justify-center space-y-4 flex-col">
              {legal.map((link) => (
                <a
                  key={link.name}
                  className="transition-colors hover:text-black text-muted dark:text-muted-dark dark:hover:text-neutral-400 text-xs sm:text-sm"
                  href={link.href}
                  target="_blank"
                >
                  {link.name}
                </a>
              ))}
              {links2.map((link) => (
                <a
                key={link.name}
                className="transition-colors hover:text-black text-muted dark:text-muted-dark dark:hover:text-neutral-400 text-xs sm:text-sm"
                href={link.href}
              >
                {link.name}
              </a>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="max-sm:px-4 sm:container mx-auto ">
        <p className="text-center mb-[40px] text-4xl xs:text-6xl sm:text-7xl md:text-8xl lg:text-9xl 2xl:text-[11.5rem] font-bold bg-clip-text text-transparent bg-gradient-to-b from-neutral-50 dark:from-neutral-950 to-neutral-200 dark:to-neutral-800 inset-x-0">
          WHIZMANAGE
        </p>
      </div>
      <footer className="bg-black"></footer>
    </div>
  );
};
